export default __webpack_public_path__ + "static/media/Bench400.7ab1c47d.jpg";